import { Link } from "react-router-dom";
import WorkCard from "@/components/base/WorkCard";
import { works } from "@/mocks/works";
import type { Work } from "@/types";

export default function FeaturedWorks() {
  const featured: Work[] = [...works]
    .sort((a, b) => b.year - a.year)
    .slice(0, 8) as Work[];

  return (
    <section className="px-5 md:px-10 py-14 md:py-20 bg-background-100">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8 md:mb-10">
        <div>
          <span className="text-xs font-medium tracking-[0.2em] uppercase text-accent-600">
            Latest Works
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-2">
            最新影视作品
          </h2>
        </div>
        <Link
          to="/works"
          className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-accent-600 transition-colors whitespace-nowrap"
        >
          查看全部作品
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {featured.map((work) => (
          <WorkCard key={work.id} work={work} />
        ))}
      </div>
    </section>
  );
}